<template>
  <!-- <main class="main-wrapper"> -->
    <section id="top" class="exhibitor-detail__wrapper">
      <div class="container-row">
        <div class="exhibitor-header">
          <h3>EXHIBITOR DETAILS</h3>
          <div class="btn-secondary">
            <router-link class="bck-btn" :to="{ name: 'home' }">
              Back to Exhibitor List
            </router-link>
          </div>
        </div>
      </div>
      <div class="container-row">
        <div class="details_outer_block">
          <div class="details_text_block">
            <div class="company_image_left">
              <div class="company_image">
                <img v-if="companyLogo == null || companyLogo == ''" :src="logoSrc" alt="">
                <img v-else :srcset="companyLogo" alt="">
              </div>
            </div>
            <div class="company_description">
              <h4>{{ companyName }}</h4>
              <small> {{ countryName }} <b>{{ standNumber }}</b></small>
              <h6 v-if="description">COMPANY PROFILE</h6>
              <p>{{ description }}</p>
              <div class="d-flex"> <span v-for="products in productCategories" v-bind:key="products.Id">{{
                products.ProductCategories }}</span>
              </div>
              <p v-if="websiteLink">
                <a target="_blank" :href="websiteLink" class="link"><img>

                  Visit Website</a>
              </p>
            </div>
          </div>
          <div class="tabs__wrapper main-tab">
            <ul class="tabs-nav">
            <li class="tab1"><a onclick="myFunctionProduct(); setActiveTab(this)">Product</a></li>
            <li class="tab2" v-if="productCategories.length > 0"> <a 
                onclick="myFunctionProductCategories(); setActiveTab(this)">Product Categories</a></li>
            <li class="tab3" v-if="pressReleases.length > 0"> <a 
                onclick="myFunctionPressReleases(); setActiveTab(this)">Press Releases</a></li>
            <li class="tab4" v-if="brochure.length > 0"> <a 
                onclick="myFunctionBrochures(); setActiveTab(this)">Brochures</a></li>
            <li class="tab5" v-if="videos.length > 0"> <a 
                onclick="myFunctionVideos(); setActiveTab(this)">Videos</a></li>
            </ul>
            <div class="tab_container">

              <div v-if="eventname === 'wuc'" class="tab-inner" id="tab1">
                <div class="popup-gallery" v-if="productGallery.length > 0">
                  <div class="product-info_wrapper" v-for="product in productGallery" v-bind:key="product.Id">
                    <span class="open-modal" onclick="myFunction()">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" viewBox="0 0 30 30" width="20px"
                        height="20px">
                        <path
                          d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16,21h-2v-7h2V21z M15,11.5 c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S15.828,11.5,15,11.5z" />
                      </svg></span>
                    <div class="info__wrapper" id="myDIV">
                      <div class="close" onclick="myFunction1()">x</div>
                      <img :src="product.PhyicalPath">
                    </div>
                    <div class="row"> <img :src="product.PhyicalPath">
                      <br>
                      <p><b>{{ product.Name }}</b></p>
                      <p>{{ product.Desciption }}</p>
                    </div>
                  </div>
                </div>
                <span v-else>No Data Found</span>
              </div>
              <div v-else class="tab-inner" id="tab1">
                <div class="popup-gallery" v-if="productGallery.length > 0">
                  <div class="product-info_wrapper" v-for="product in productGallery" v-bind:key="product.Id">
                    <span class="open-modal" onclick="myFunction1()">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" viewBox="0 0 30 30" width="20px"
                        height="20px">
                        <path
                          d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16,21h-2v-7h2V21z M15,11.5 c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S15.828,11.5,15,11.5z" />
                      </svg></span>
                    <div class="info__wrapper" id="myDIV">
                      <div class="close" onclick="myFunction1()">x</div>
                      <img :src="product.PhyicalPath">
                    </div>
                    <div class="row"> <img :src="product.Image">
                      <br>
                      <p><b>{{ product.ImageTitle }}</b></p>
                      <p>{{ product.ImageDesciption }}</p>
                    </div>
                  </div>
                </div>
                <span v-else>No Data Found</span>
              </div>

              <div v-if="eventname === 'wuc'" class="tab-inner product-category-div" id="tab2" style="display: none;">
                <ul v-if="productCategories.length > 0">
                  <h6>Product Categories</h6>
                  <li v-for="products in productCategories" v-bind:key="products.Id">
                    <span>{{products}}</span><br />
                  </li>
                </ul>
                <span v-else>No Data Found</span>
              </div>
              <div v-else class="tab-inner product-category-div" id="tab2" style="display: none;">
                <ul v-if="productCategories.length > 0">
                  <h6>Product Categories</h6>
                  <li v-for="products in productCategories" v-bind:key="products.Id">
                    <span>{{ products.ProductCategories }}</span><br />
                  </li>
                </ul>
                <span v-else>No Data Found</span>
              </div>

              <div v-if="eventname === 'wuc'" class="tab-inner pressReleases-div" id="tab3" style="display: none;">
                <ul v-if="pressReleases.length > 0">
                  <h6>Press Releases</h6>
                  <li v-for="press in pressReleases" v-bind:key="press.PressReleaseId">
                    <span>
                      <a v-bind:href="press.PhyicalPath" target="_blank">
                        {{ press.Name }}
                      </a> </span><br />
                  </li>
                </ul>
                <span v-else>No Data Found</span>
              </div>
              <div v-else class="tab-inner pressReleases-div" id="tab3" style="display: none;">
                <ul v-if="pressReleases.length > 0">
                  <h6>Press Releases</h6>
                  <li v-for="press in pressReleases" v-bind:key="press.PressReleaseId">
                    <span>
                      <a v-bind:href="press.Abstract" target="_blank">
                        {{ press.Title }}
                      </a> </span><br />
                  </li>
                </ul>
                <span v-else>No Data Found</span>
              </div>

              <div v-if="eventname === 'wuc'"  class="tab-inner brochure-div" id="tab4" style="display: none;">
                <ul v-if="brochure.length > 0">
                  <h6>Brochures</h6>
                  <li v-for="brochureitem in brochure" v-bind:key="brochureitem.BrochureId">
                    <span><a target="_blank" v-bind:href="brochureitem.PhyicalPath">{{ brochureitem.Name
                        }}</a></span><br />
                  </li>
                </ul>
                <span v-else>No Data Found</span>
              </div>
              <div v-else class="tab-inner brochure-div" id="tab4" style="display: none;">
                <ul v-if="brochure.length > 0">
                  <h6>Brochures</h6>
                  <li v-for="brochureitem in brochure" v-bind:key="brochureitem.BrochureId">
                    <span><a target="_blank" v-bind:href="brochureitem.Document">{{ brochureitem.Title
                        }}</a></span><br />
                  </li>
                </ul>
                <span v-else>No Data Found</span>
              </div>

              <div class="tab-inner videos-div" id="tab5" style="display: none;">
                <div v-if="videos.length > 0">
                  <h6>Videos</h6>
                  <div v-for="videoitem in videos" v-bind:key="videoitem.VideoId" class="video-tablistblock">
                    <div class="video-gal-wrapp">

                      <div v-if="isYouTube(videoitem.VideoURL) || (videoitem.VideoURL == null && isYouTube(videoitem.Path))">
                        <iframe v-bind:src="getYouTubeEmbedUrl(videoitem.VideoURL || videoitem.Path)" width="560" height="315"
                          frameborder="0" allowfullscreen title="YouTube Video"></iframe>
                      </div>
                      <div v-else-if="isVimeo(videoitem.VideoURL) || (videoitem.VideoURL == null && isYouTube(videoitem.Path))">
                        <iframe v-bind:src="getVimeoEmbedUrl(videoitem.VideoURL || videoitem.Path)" width="560" height="315"
                          frameborder="0" allowfullscreen title="Vimeo Video"></iframe>
                      </div>
                      <div v-else>
                        <p>Unsupported video source</p>
                      </div>
                      <span class="video-caption" v-if="videoitem.Title">{{ videoitem.Title }}</span>
                      <span class="video-description" v-if="videoitem.Description">{{ videoitem.Description }}</span>
                    </div>
                  </div>
                </div>
                <span v-else>No Data Found</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  <!-- </main> -->
</template>
<script>

import axios from "axios";
import url from "./../../config/url";
export default {
  name: "ExhibitorProfilePage",
  data: function () {
    return {
      exhibitorid: this.$route.query.exhibitorid,
      standOppId: null,
      companyName: null,
      countryName: null,
      companyLogo: null,
      standNumber: null,
      address: null,
      websiteLink: null,
      contactInformation: null,
      phoneNumber: null,
      jobTitle: null,
      fax: null,
      email: null,
      description: null,
      productCategories: [],
      productGallery: [],
      PressReleases: [],
      Brochure: [],
      videos: [],
      showProductCategory: true,
    };
  }, computed: {
    logoSrc() {
      if (this.eventname === "japan") {
        return "https://www.japanenergyevent.com/media/2jsee45b/japan2025-logo.jpg";
      } 
      else if(this.eventname === "emf") {
        return "https://www.egyptminingforum.com/media/1wcjhzex/emf-header-logo.png";
      }
      if (this.eventname === "wuc") {
        return "https://www.worldutilitiescongress.com/media/rtdbps1s/wuc-logo2.jpg";
      }
      else  {
        return "https://www.japanenergyevent.com/media/2jsee45b/japan2025-logo.jpg";
      }
     
    }
  },
  mounted() {
    const url = window.location.href;
    const domain = url.split('/')[2];
    if (domain === "www.japanenergyevent.com/") {
      this.eventname = "japan";
    }
    else if (domain === "https://www.egyptminingforum.com/") {
      this.eventname = "emf";
    }
    else if (domain === "worldutilitiescongress.com") {
      this.eventname = "wuc";
    }
    else {
      this.eventname = "japan";
    }
    this.exhibitorDetails(this.exhibitorid, this.eventname);
  },

  methods: {
    exhibitorDetails: function (eId, eventname) {
      // eslint-disable-next-line no-debugger
      debugger
      let apiUrl = eventname === "wuc"
        ? url.exhibitor_detail_api_WUC
        : url.exhibitor_detail_api;
      axios
        .get(apiUrl, { params: { exhibitorid: eId } })
        .then(response => {

          this.standOppId = response.data.StandOppId;
          this.companyName = response.data.CompanyName;
          this.countryName = response.data.CountryName;
          this.standNumber = response.data.StandNumber;
          this.address = response.data.Address;
          this.websiteLink = response.data.WebsiteLink;
          this.phoneNumber = response.data.PhoneNumber;
          this.jobTitle = response.data.JobTitle;
          this.fax = response.data.Fax;
          this.email = response.data.Email;
          this.description = response.data.Description;
          this.contactInformation = response.data.ContactInformation;
          this.companyLogo = response.data.CompanyLogo;
          this.productCategories = response.data.ProductCategories;
          this.productGallery = response.data.ProductGallery;
          this.pressReleases = response.data.PressReleases;
          this.brochure = response.data.Brochure;
          this.videos = response.data.Videos;


          if (this.productGallery != null) {
            this.showProductGallery = true;
           
          }
          else if (this.productCategories != null) {
            this.showProductCategory = true;
            var productCategoriesDiv = document.getElementById("tab2");
            productCategoriesDiv.style.display = "block";
            document.getElementsByClassName('tab2')[0].style.display = 'block';

          }
        })
    },
    exhibitorProductGallery: function () {
      (this.showProductGallery = true),
        (this.showProductCategory = false);
    },
    exhibitorProductData: function () {
      (this.showProductCategory = true),
        (this.showProductGallery = false);
    }, isYouTube(url) {

      // eslint-disable-next-line no-debugger
      debugger
      if (typeof url !== 'string') {
        //console.error("Invalid URL:", url);
        return false;
      }

      return url.includes("youtube.com") || url.includes("youtu.be");
    },
    
    getYouTubeEmbedUrl(url) {
      const videoId = this.getYouTubeVideoId(url);
      return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
    },

    getYouTubeVideoId(url) {
      let videoId = '';

      try {
        const urlObj = new URL(url);

        if (urlObj.hostname === 'youtu.be') {
          // Handle youtu.be format
          videoId = urlObj.pathname.substring(1);
        } else if (urlObj.hostname === 'www.youtube.com' && urlObj.pathname === '/watch') {
          // Handle youtube.com/watch?v=xxx format
          const searchParams = new URLSearchParams(urlObj.search);
          videoId = searchParams.get('v');
        }
      } catch (error) {
        // Handle URL parsing errors
        //console.error('Error parsing URL:', error);
      }

      return videoId;
    },
    isVimeo(url) {
      if (typeof url !== 'string') {
        //console.error("Invalid URL:", url);
        return false;
      }
      return url.includes("vimeo.com");
    },
    getVimeoEmbedUrl(url) {
      const videoId = this.getVimeoVideoId(url);
      return videoId ? `https://player.vimeo.com/video/${videoId}` : '';
    },
    getVimeoVideoId(url) {
      // Extract Vimeo video ID using simple string manipulation
      const parts = url.split("/");
      return parts[parts.length - 1] || '';
    },
  }
};

</script>
<style>
.main-exhibitorlist-heading {
  display: none;
}

div#tab2 {
  display: none;
}

div#tab3 {
  display: none;
}

div#tab4 {
  display: none;
}

div#tab5 {
  display: none;
}
</style>
